import { DatasourceListViewData, DatasourceState, DatasourceStoreModel, DatasourceUIModel } from '@y42/datasource';
import { UiModelingSettings } from '@y42/json-schema';
import { DataModelGoJSModel } from '../models/data-model-gojs.model';

export class UiModelingSettingsGitModel extends UiModelingSettings {
  constructor(model: UiModelingStoreModel) {
    super();
    const settings = model.settings;
    this.$schema = settings.$schema;
  }
}

export class UiModelingStoreModel extends DatasourceStoreModel<UiModelingSettingsGitModel> {}

export interface UiModelingUIModel extends DatasourceUIModel<UiModelingStoreModel> {
  getUiModel?: () => Promise<DataModelGoJSModel | undefined | null>;
}

export type UiModelingState = DatasourceState<UiModelingStoreModel>;

export type UiModelingListViewData = DatasourceListViewData;
